import { createConsumer } from '@rails/actioncable';
import { BUS_EVENTS_SHOP } from './constant';

const PRESENCE_INTERVAL = 20000;

class BaseActionCableConnectorShop {
  constructor(app, contactId, pubsubToken, user={},websocketHost = '') {
    const websocketURL = websocketHost ? `${websocketHost}/cable` : undefined;
    this.consumer = createConsumer(websocketURL);
    this.subscription = this.consumer.subscriptions.create(
      {
        channel: 'MenuChannel',
        pubsub_token: pubsubToken,
        contact_id: contactId,
        user_id: user.user_id,
        account_id: user.account_id,
        // user_id: app.$store.getters.getCurrentUserID,
      },
      {
        updatePresence() {
          this.perform('update_presence');
        },
        received: this.onReceived,
        disconnected: this.onDisconnected,
      }
    );
    this.app = app;
    this.events = {};
    this.isAValidEvent = () => true;

    setInterval(() => {
      this.subscription.updatePresence();
    }, PRESENCE_INTERVAL);
  }

  disconnect() {
    this.consumer.disconnect();
  }

  // eslint-disable-next-line class-methods-use-this
  onDisconnected() {
    window.bus.$emit(BUS_EVENTS_SHOP.WEBSOCKET_DISCONNECT);
  }

  onReceived = ({ event, data } = {}) => {
    if (this.isAValidEvent(data)) {
      if (this.events[event] && typeof this.events[event] === 'function') {
        this.events[event](data);
      }
    }
  };
}

export default BaseActionCableConnectorShop;
